import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdateInveriteRows from './buildUpdateInveriteRows.helper';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateInveriteProps = {
  onSubmit: (params: vp.SetInveriteCredentialsRequest) => void;
  onBack: () => void;
  defaultValues: vp.SetInveriteCredentialsRequest;
};
type FC = FunctionComponent<UpdateInveriteProps>;

const UpdateInveriteReview: FC = (props: UpdateInveriteProps) => {
  const { onSubmit, defaultValues, onBack } = props;
  const updateInveriteRows = useBuildUpdateInveriteRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Inverite.Update.Review' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ values, handleSubmit }) => {
        const updateInveriteTable: vp.TableProps = {
          name: 'update-inverite-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateInveriteRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={values[id]}
                disabled
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="lg" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateInveriteTable} />
            <Box width="100%" jc="fe" mt="md">
              <Button id="inverite-submit" type="submit" label={tGlobal('Buttons.save')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateInveriteReview;
